import styled from '@olxui/core/dist/theme/styled';
import { AdCardTitle } from '../BookingCalendar.components';

export const Container = styled.div`
    width: 100%;
    margin-bottom: ${({ theme }) => `${theme.space[12]}`};
`;

export const Row = styled.div`
    margin-bottom: ${({ theme }) => `${theme.space[10]}`};
`;

export const StyledCostTitle = styled(AdCardTitle)`
    margin-bottom: ${({ theme }) => `${theme.space[10]}`};
`;

export const StyledCostBox = styled.div`
    color: ${({ theme }) => `${theme.colors['text-brand-primary']}`};
    padding: ${({ theme }) => `${theme.space[10]}`};
    background-color: ${({ theme }) => `${theme.colors['$02_gray']}`};
`;

export const StyledCostBoxRow = styled.div`
    display: flex;
    line-height: 1.5em;
    margin-top: 0;
    & + & {
        margin-top: ${({ theme }) => `${theme.space[10]}`};
    }
`;

export const StyledCostBoxCol = styled.div`
    width: 50%;
`;
